import * as echarts from "echarts";
import type { EChartsOption } from "echarts";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

export interface ProfileChartRef {
    updateChart: (option: EChartsOption) => void;
}
export interface ProfileChartProps {
    chartOption?: EChartsOption;
    height?: number | string;
}

/** 用户画像图表容器，复用旧 Vue 的 ECharts 初始化、更新和 resize 行为。 */
const ProfileChart = forwardRef<ProfileChartRef, ProfileChartProps>(function ProfileChart(
    { chartOption = {}, height = 320 },
    ref
) {
    const containerRef = useRef<HTMLDivElement>(null);
    const chartRef = useRef<echarts.ECharts | null>(null);
    useEffect(() => {
        const container = containerRef.current;
        // jsdom 和折叠容器没有可用尺寸时跳过初始化，真实页面布局完成后由浏览器重绘。
        if (!container || container.clientWidth === 0 || container.clientHeight === 0) return;
        chartRef.current = echarts.init(container);
        const resize = () => chartRef.current?.resize();
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
            chartRef.current?.dispose();
            chartRef.current = null;
        };
    }, []);
    useEffect(() => {
        chartRef.current?.setOption(chartOption);
    }, [chartOption]);
    useImperativeHandle(ref, () => ({ updateChart: option => chartRef.current?.setOption(option) }), []);
    return <div ref={containerRef} aria-label="用户画像图表" style={{ width: "100%", height }} />;
});
export default ProfileChart;
